export { DeviceStatusBadgeComponent } from '../components/device-status-badge/device-status-badge.component';
